/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { ZipCodeTotalsViewModel } from './ZipCodeTotalsViewModel'; 

export function getZipCodeTotalsOptions(onSuccess?: (result: ZipCodeTotalsViewModel) => void) {
	return queryOptions({
		queryKey: ['zip-code-totals'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/referrals/queries/getzipcodetotals/';
			const resp = await axios.get<ZipCodeTotalsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}